import { useEffect } from "react";
import { Pressable, Text, View } from "react-native";
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withSpring,
} from "react-native-reanimated";

interface ToggleProps {
  value: boolean;
  onValueChange: (value: boolean) => void;
  label: string;
  description?: string;
}

export function Toggle({
  value,
  onValueChange,
  label,
  description,
}: ToggleProps) {
  const togglePos = useSharedValue(value ? 1 : 0);

  useEffect(() => {
    togglePos.value = withSpring(value ? 1 : 0, {
      damping: 20,
      stiffness: 300,
    });
  }, [value, togglePos]);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ translateX: togglePos.value * 24 + 2 }],
  }));

  return (
    <View className="flex-row items-center justify-between py-4">
      <View className="flex-1 pr-4">
        <Text className="text-foreground text-sm font-medium">{label}</Text>
        {description && (
          <Text className="text-muted-foreground mt-0.5 text-xs">
            {description}
          </Text>
        )}
      </View>
      <Pressable
        onPress={() => onValueChange(!value)}
        accessibilityRole="switch"
        accessibilityState={{ checked: value }}
        className={`h-8 w-14 justify-center rounded-full ${value ? "bg-brand" : "bg-accent"}`}
      >
        <Animated.View
          className={`absolute size-6 rounded-full ${value ? "bg-background" : "bg-foreground"}`}
          style={animatedStyle}
        />
      </Pressable>
    </View>
  );
}
